import React from 'react';
import styled from 'styled-components';
import { formatPhoneNumber } from 'utilities/strings';

import Typography from '@material-ui/core/Typography';

const AddressDisplayItem = styled(({ ...other }) => (
  <Typography variant="body1" {...other} />
))`
  margin-bottom: 6px;
  line-height: 1.1;
  &:empty {
    margin-bottom: 0;
  }
`;

const OrderAddressDisplay = ({
  first_last,
  notification_email,
  country_name,
  company_name,
  city_state_zip,
  phone,
  street_address_1,
  street_address_2
}) => (
  <>
    <AddressDisplayItem>{first_last}</AddressDisplayItem>
    <AddressDisplayItem>{company_name}</AddressDisplayItem>
    <AddressDisplayItem>{street_address_1}</AddressDisplayItem>
    <AddressDisplayItem>{street_address_2}</AddressDisplayItem>
    <AddressDisplayItem>{city_state_zip}</AddressDisplayItem>
    <AddressDisplayItem>{country_name}</AddressDisplayItem>
    <AddressDisplayItem>{formatPhoneNumber(phone)}</AddressDisplayItem>
    {notification_email && (
      <AddressDisplayItem>
        Notifications sent to: {notification_email}
      </AddressDisplayItem>
    )}
  </>
);

export default OrderAddressDisplay;
